export default "__VITE_ASSET__BvfJQh0J__"